import { render, staticRenderFns } from "./ValidationIcon.vue?vue&type=template&id=202450b6"
import script from "./ValidationIcon.vue?vue&type=script&lang=js"
export * from "./ValidationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports